import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { createIntegrationChain } from '../index';
export const useCreateIntegrationChain = () => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(createIntegrationChain, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetIntegrationChainDescriptionList');
            setAction({
                type: 'success',
                message: 'Creation of the integration chain was successful',
            });
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
